import React from "react";

const About = () => {
  return (
    <div className="content">
      <h1 className="title">
        Herzlich willkommen auf der Köln-Atlas-Seite –<br />
        Ihre Suchmaschine für soziale Einrichtungen
      </h1>

      <p>
        Der Köln-Atlas funktioniert mit allen modernen Browsern auf Computern,
        Tablets und Handys. Für eine Nutzung ist keine Registrierung notwendig.
      </p>

      <h2 className="subtitle">Was finde ich im Köln-Atlas?</h2>
      <p>
        Im Köln-Atlas finden Sie soziale Einrichtungen und deren Angebote aus
        den Stadtbezirken Nippes und Mülheim, perspektivisch soll das Angebot
        auf alle Bezirke in Köln ausgeweitet werden. Sie finden hier
        Beschreibungen zu einzelnen Angeboten, können sich aber auch individuell
        zusammengestellte Suchlisten generieren lassen.
      </p>

      <h2 className="subtitle">Wie suche ich im Köln-Atlas?</h2>
      <p>
        Sie können Ihre Suche nach Stadtteilen und Kategorien (auch
        unterschiedlichen) filtern. Bei der Stadtteil-Suche ist der Stadtteil
        zur besseren Orientierung grün unterlegt. Zusätzlich haben Sie die
        Möglichkeit, mit der Freitext-Suche nach Namen oder Schlagworten zu
        suchen.
      </p>
      <p>
        Möchten Sie weitere Informationen zu Ihrer gesuchten Einrichtung haben,
        können Sie mit einem Klick in die Liste der Suchergebnisse die
        gewünschte Einrichtung auswählen. Auf der Karte wird die geografische
        Lage der Einrichtung angezeigt. Über das »Augen-Symbol« haben Sie die
        Möglichkeit, weitere Informationen zur Einrichtung zu bekommen.
        Zusätzlich gibt es über das »Auto-Symbol« eine Verknüpfung zu
        Google-Maps, mit der Sie sich eine Wegbeschreibung erstellen lassen
        können. Falls Sie mobil auf den Köln-Atlas zugreifen, können Sie aus dem
        Ergebnisfenster heraus direkt bei der Einrichtung anrufen.
      </p>

      <h2 className="subtitle">Suchergebnisse ausdrucken</h2>
      <p>
        Unmittelbar nach Auswahl der Suchkriterien erscheinen in der linken
        Spalte die Suchergebnisse. Um diese Suchergebnisse auszudrucken, können
        Sie oberhalb der Suchergebnisse mit einem Klick auf das PDF-Symbol eine
        PDF-Datei mit den Ergebnissen generieren.
      </p>

      <h2 className="subtitle">
        Wie kann ich eine Einrichtung im Köln-Atlas eintragen?
      </h2>
      <p>
        Wenn Sie eine neue Einrichtung im Köln-Atlas eintragen wollen, müssen
        Sie sich vorab mit Namen, E-Mail-Adresse und Passwort registrieren. Über
        die E-Mail-Adresse wird Ihnen eine Bestätigungsmail zugesandt, mit der
        Sie die Registrierung abschließen. Danach können Sie sich über den
        Menü-Punkt »Einrichtung anlegen« eine neue Einrichtung anlegen. Füllen
        Sie dafür die vorgesehenen Felder aus. Um Ihre Einrichtung über die
        Freitext-Suche zu finden, ist es wichtig, dass Sie beim letzten
        Eingabefeld <strong>»Angebot in Stichworten«</strong> Ihre Stichworte
        auswählen oder neue anlegen.
      </p>
      <p>
        Sobald Sie Ihre Eingabe beendet haben (»speichern« drücken), wird Ihre
        Eingabe noch vom Administrator der Köln-Atlas-Seite geprüft und
        freigegeben. Dies ist wichtig, damit wir eine Qualitätssicherung wahren
        können. Danach erhalten Sie eine Bestätigung über Ihre Freigabe. Erst
        dann ist Ihr Eintrag online.
      </p>

      <h2 className="subtitle">
        Wie kann ich eine Einrichtung im Köln-Atlas ändern?
      </h2>
      <p>
        Über den Menü-Punkt »Anmelden« können Sie sich als registrierter Nutzer
        anmelden und Ihre Daten aktualisieren. Dafür ist wieder das Passwort und
        die E-Mail-Adresse notwendig. Zur Qualitätssicherung bekommen nach
        Abschluss Ihrer Aktualisierung sowohl der Administrator dieser Seite als
        auch Sie als angemeldeter Nutzer eine E-Mail.
      </p>

      <h2 className="subtitle">Ich habe mein Passwort vergessen.</h2>
      <p>
        Falls Sie Ihr Passwort vergessen haben, wird Ihnen nach einem Klick auf
        »Passwort vergessen« eine E-Mail zugesandt, mit der Sie ein neues
        Passwort erstellen können.
      </p>

      <h2 className="subtitle">
        Sie wollen den Köln-Atlas bekannter machen oder neue Stadtbezirke
        miteinbeziehen?
      </h2>
      <p>
        Über jede Form von Unterstützung und Mitarbeit bei der Verbreitung des
        Köln-Atlas freuen wir uns. Bitte setzen Sie sich mit uns (siehe
        Impressum) in Verbindung.
      </p>
      <p />
    </div>
  );
};

export default About;



/** WEBPACK FOOTER **
 ** ./src/components/About.jsx
 **/